// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  allRightsReserved: (t, data?, options?) => t('enum.copyright-license.all-rights-reserved.name', data, options),
  creativeCommonsBy: (t, data?, options?) => t('enum.copyright-license.creative-commons-by.name', data, options),
  creativeCommonsBySa: (t, data?, options?) => t('enum.copyright-license.creative-commons-by-sa.name', data, options),
  publicDomain: (t, data?, options?) => t('enum.copyright-license.public-domain.name', data, options),
  /* eslint-enable max-len */
};
